import { FC } from 'react';
import { useTitle } from 'react-use';

import { RouteTabs } from '@savgroup-front-common/core/atoms/RouteTabs';
import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign/MyAccount.icon';
import { ICONS_TYPE } from '@savgroup-front-common/types';
import BanneredLayout from '@/view/app/NewLayout/BanneredLayout/BanneredLayout';
import { useLayout } from '@/view/app/NewLayout/NewLayout.hooks';

import { $HomeContentWrapper } from './HomePage.styles';
import useHomeTabs from './hooks/useHomeTabs';
import messages from './messages';

const HomePage: FC = () => {
  const { login } = useLayout();
  const { tabsConfig } = useHomeTabs();

  useTitle(buildPageTitle([messages.homeTitlePage]));

  return (
    <BanneredLayout isHomePage>
      <BanneredLayout.BannerTitle
        title={{
          ...messages.bannerTitle,
          values: { userName: login.firstName || '' },
        }}
        description={messages.bannerDescription}
      />
      <BanneredLayout.Content>
        <$HomeContentWrapper>
          <RouteTabs
            config={tabsConfig.map((tab) => ({
              ...tab,
              icon: <MyAccountIcon icon={tab.icon as ICONS_TYPE} />,
            }))}
            hasBottomBorder
            hideButton
            level={2}
          />
        </$HomeContentWrapper>
      </BanneredLayout.Content>
    </BanneredLayout>
  );
};

export default HomePage;
